<template>
  <div>
    <div class="mx-4 mt-4 black--text">
      <div class="body-1 font-weight-medium">Petunjuk Pengisian</div>
      <ol>
        <li>Bacalah instrumen pengisian penilaian penugasan pelatihan pengimbasan PSP Angkatan 1</li>
        <li>Pilihlah salah satu skala dari masing-masing aspek penugasan dari setiap materi</li>
      </ol>
    </div>
    <div class="mx-4 mt-5 black--text">
      <div class="body-1 font-weight-medium">Keterangan skala rubrik penilaian</div>
      <ul>
        <li>1: Mulai Berkembang</li>
        <li>2: Berkembang</li>
        <li>3: Mahir</li>
        <li>4: Sangat Mahir</li>
      </ul>
    </div>
    <v-card v-for="item in rubrikKetrampilan" outlined class="mx-3 my-6" :key="item.k_pelatihan_rubrik_psp">
      <v-card-text>
        <div class="title black--text">{{ item.aspek }}</div>
        <div class="subtitle-2 grey--text font-weight-regular">{{ item.tugas }}</div>
        <v-list class="mt-4">
          <div v-for="(rubrik, rubrikId) in item.rubrik" :key="rubrikId">
            <v-divider v-if="rubrikId > 0" class="mb-5 mt-4" />
            <v-list-item class="px-0">
              <v-row>
                <v-col cols="12" md="6">
                  <div class="blue--text body-1">
                    {{ rubrik.keterangan }}
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div>
                    <div class="black--text"><strong>Penilaian</strong></div>
                    Berapa skala penialaian aspek penugasan untuk materi berikut?
                  </div>
                  <div>
                    <div class="radio-outline mx-0">
                      <v-btn
                        small
                        :outlined="+skor !== form[rubrik.k_pelatihan_rubrik_psp]"
                        color="orange"
                        :class="['mr-1', +skor === form[rubrik.k_pelatihan_rubrik_psp] ? 'white--text' : '']"
                        v-for="skor in item.opsi || []"
                        :key="skor"
                        @click="onChangeNilai(rubrik, skor)"
                      >
                        {{ skor }}
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-list-item>
          </div>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    initValue: {
      type: Object,
      default: () => {},
    },
    rubriks: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'form',
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    rubrikKetrampilan() {
      return [
        {
          aspek: 'Semangat Belajar, Berbagi dan Berkolaborasi bagi Pendidik dan Tenaga Kependidikan',
          tugas: 'Rencana Berbagi Praktik Baik',
          rubrik: this.rubriks.filter((item) => item.aspek_id === 'semangat'),
          opsi: [1, 2, 3, 4],
        },
        {
          aspek: 'Coaching, Fasilitasi, Mentoring',
          tugas: 'Latihan Percakapan dengan Klien Menggunakan Presence dan RASA',
          rubrik: this.rubriks.filter((item) => item.aspek_id === 'coaching'),
          opsi: [1, 2, 3, 4],
        },
        {
          aspek: 'Refleksi Diri dan Umpan Balik yang Membangun',
          tugas: 'Latihan Refleksi Diri dan Latihan Memberikan Umpan Balik',
          rubrik: this.rubriks.filter((item) => item.aspek_id === 'refleksi-diri'),
          opsi: [1, 2, 3, 4],
        },
        {
          aspek: 'Refleksi dan Berbagi Implementasi PSP',
          tugas: 'Pemetaan Refleksi dan berbagi Implementasi PSP',
          rubrik: this.rubriks.filter((item) => item.aspek_id === 'refleksi-berbagi'),
          opsi: [1, 2, 3, 4],
        },
        {
          aspek: 'Penyusunan Rencana Kerja',
          rubrik: this.rubriks.filter((item) => item.aspek_id === 'rencana'),
          opsi: [1, 2, 3, 4],
        },
      ];
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});

      this.$nextTick(() => {
        const pspPelatihanKelasNilais = this.initValue['psp_pelatihan_kelas_nilais'] || [];
        const pspPelatihanKelasNilai = pspPelatihanKelasNilais[0] || {};
        const nilais = pspPelatihanKelasNilai.psp_pelatihan_kelas_rubriks || [];

        for (const nilai of nilais) {
          const kelompokId = this.$getDeepObj(nilai, 'm_pelatihan_rubrik_psp.kelompok_id');
          if (kelompokId === 'keterampilan') {
            this.$set(this.form, nilai.k_pelatihan_rubrik_psp, nilai.k_nilai_psp);
          }
        }
      });
    },

    getValue() {
      return this.form || {};
    },

    onChangeNilai(item, skor) {
      if (this.mode !== 'form') return;
      this.$set(this.form, item.k_pelatihan_rubrik_psp, Number(skor));
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
